import React from 'react';
import classnames from 'classnames';
import cls from './index.module.scss';

export type SectionTemplateProps = {
  children: React.ReactNode;
  size?: 'full' | 'contained';
  clsName?: string;
};

export const Section = (props: SectionTemplateProps) => {
  const { clsName, size = 'contained', children } = props;

  return <div className={classnames(cls[size], clsName)}>{children}</div>;
};
